export const DOMAIN =
  process.env.NODE_ENV === 'production'
    ? ''
    : // : 'https://crm-nightly-new.cc.capillarytech.com';
      'http://localhost:2100';
export const WS_DOMAIN =
  process.env.NODE_ENV === 'production'
    ? `wss://${window.location.host}`
    : // : 'wss://devenv-crm.cc.capillarytech.com';
      'ws://localhost:2100';
export const AIRA_REDUCER_DOMAIN = 'ASK_AIRA';

export const rootClsPrefix = 'cap-ask-aira';
